import { datadogRum } from '@datadog/browser-rum';

const STORAGE_PREFIX = 'cardfinder:funnel:';

export function readSession<T>(key: string): T | undefined {
  if (typeof window === 'undefined') return undefined;
  try {
    const raw = window.sessionStorage.getItem(STORAGE_PREFIX + key);
    return raw ? (JSON.parse(raw) as T) : undefined;
  } catch (error) {
    datadogRum.addError(error instanceof Error ? error : new Error('Session storage read failed'));
    return undefined;
  }
}

export function writeSession<T>(key: string, value: T): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(value));
  } catch (error) {
    datadogRum.addError(error instanceof Error ? error : new Error('Session storage write failed'));
  }
}

export function removeFromSession(key: string): void {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(STORAGE_PREFIX + key);
}
